<template>
    <div class="card card-body shadow-sm">
        <form @submit.prevent="StoreData" method="post">
            <div class="row">
                <div class="form-group mb-3 col-2">
                    <label>Kode</label>
                    <input type="text" name="kode" class="form-control" :class="errors.kode ? 'is-invalid' : ''" placeholder="Kode" v-model="this.data.kode">
                    <div class="invalid-feedback">{{ errors.kode }}</div>
                </div>
                <div class="form-group mb-3 col-4">
                    <label>No Register</label>
                    <input type="text" name="identity" class="form-control" :class="errors.identity ? 'is-invalid' : ''" placeholder="identity" v-model="this.data.identity">
                    <div class="invalid-feedback">{{ errors.identity }}</div>
                </div>
                <div class="form-group mb-3 col-6">
                    <label>Nama</label>
                    <input type="text" name="alat_berat" class="form-control" :class="errors.nama ? 'is-invalid' : ''" placeholder="Nama" v-model="this.data.nama">
                    <div class="invalid-feedback">{{ errors.nama }}</div>
                </div>
            </div>
            <div class="row">
                <div class="form-group mb-3 col-6">
                    <label>Merk</label>
                    <input type="text" name="merk" class="form-control" :class="errors.merk ? 'is-invalid' : ''" placeholder="merk" v-model="this.data.merk">
                    <div class="invalid-feedback">{{ errors.merk }}</div>
                </div>
                <div class="form-group mb-3 col-6">
                    <label>Type</label>
                    <input type="text" name="type" class="form-control" :class="errors.type ? 'is-invalid' : ''" placeholder="type" v-model="this.data.type">
                    <div class="invalid-feedback">{{ errors.type }}</div>
                </div>
            </div>
            <div class="form-group">
                <label>Bahan Bakar</label>
                <input type=" text" name="bahan_bakar" class="form-control" :class="errors.bahan_bakar ? 'is-invalid' : ''" placeholder="Bahan Bakar" v-model="this.data.bahan_bakar">
                <div class="invalid-feedback">{{ errors.bahan_bakar }}</div>
            </div>
            <div class="form-group mb-3">
                <label>Biaya Per Jam</label>
                <input type="number" name="biaya_per_jam" class="form-control" :class="errors.jumlah ? 'is-invalid' : ''" placeholder="Biaya Per jam (dalam Rupiah)" v-model="this.data.biaya_per_jam">
                <div class="invalid-feedback">{{ errors.jumlah }}</div>
            </div>
            <div class="form-group mb-3">
                <label>Jumlah Alat Berat</label>
                <input type="number" name="jumlah" class="form-control" :class="errors.jumlah ? 'is-invalid' : ''" placeholder="Jumlah" v-model="this.data.jumlah">
                <div class="invalid-feedback">{{ errors.jumlah }}</div>
            </div>
            <div class="d-flex" :class="id ? 'justify-content-between' : 'justify-content-end'">
                <owl-delete-button class="mb-0" :url="'penyewaan/master/alat_berat/' + id" redirectUrl="penyewaan.alat-berat" v-if="id">Hapus</owl-delete-button>
                <button type="submit" class="btn bg-gradient-success mb-0">Simpan</button>
            </div>
        </form>
</div>
</template>

<script>
import OwlDeleteButton from '@/components/OwlDeleteButton.vue';

export default {
    name: "MapForm",
    components: { OwlDeleteButton },
    data() {
        return {
            id: this.$route.params.id,
            data: {
                disewakan: 0
            },
            errors: {}
        }
    }, mounted() {
        if (this.id) {
            this.axios.get('penyewaan/master/alat_berat/' + this.id).then((response) => {
                this.data = response.data;
            });
        }
    }, methods: {
        StoreData() {
            if (this.id) {
                this.axios.put('penyewaan/master/alat_berat/' + this.id, this.data).then((response) => {
                    if (response.data.error) {
                        this.errors = response.data.message;
                    } else {
                        this.$router.push({ name: 'penyewaan.alat-berat' });
                    }
                });
            } else {
                this.axios.post('penyewaan/master/alat_berat', this.data).then((response) => {
                    if (response.data.error) {
                        this.errors = response.data.message;
                    } else {
                        this.$router.push({ name: 'penyewaan.alat-berat' });
                    }
                });
            }
        }
    }
}
</script>